import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// ANTD

// COMPONENTS & UTILS
import ButtonVoltar from 'components/Common/ButtonVoltar';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { clearNotifications } from 'store/modules/app/notifications/actions';
import { consultaPesquisaObservacaoClear } from 'store/modules/api/iirgd/consultaPesquisaObservacao/actions';
import { cadastroRgConfigRedicao } from 'store/modules/api/iirgd/cadastroRg/actions';
import { ConsultarCpfCin } from 'store/modules/api/iirgd/integrador/consultarCin/types';
import { IFormCadastroRg } from '../form';
import {
	ROUTE_IIRGD_CADASTRO,
	ROUTE_IIRGD_EDICAO,
	ROUTE_IIRGD_INCLUSAO_OBSERVACOES,
	ROUTE_IIRGD_PESQUISAR_RG,
} from '../../routes/paths';
import DivergenceForm from './DivergenceForm';
import CipteaForm from './CipteaForm';

const DivergenciasScreen: React.FC = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();

	const { cadastroRg } = useSelector(
		(state: ApplicationState) => state.api.iirgd,
	);

	const [divergenceComplete, setDivergenceComplete] = useState(false);
	const [cipteaComplete, setCipteaComplete] = useState(false);

	const { showCiptea, showDivergence, formData, consultarCinData } =
		(location.state as {
			showCiptea: boolean;
			showDivergence: boolean;
			formData: IFormCadastroRg;
			consultarCinData: ConsultarCpfCin;
		}) || {
			showCiptea: false,
			showDivergence: false,
			formData: {} as IFormCadastroRg,
			consultarCinData: {} as ConsultarCpfCin,
		};

	useEffect(() => {
		const handleAdvance = () => {
			history.push(ROUTE_IIRGD_INCLUSAO_OBSERVACOES);
		};
		if (
			(!showCiptea && showDivergence && divergenceComplete) ||
			(!showDivergence && showCiptea && cipteaComplete)
		) {
			handleAdvance();
		} else if (
			showDivergence &&
			divergenceComplete &&
			showCiptea &&
			cipteaComplete
		) {
			handleAdvance();
		}
	}, [cipteaComplete, divergenceComplete, history, showCiptea, showDivergence]);

	if (!showCiptea && !showDivergence) {
		history.replace(ROUTE_IIRGD_PESQUISAR_RG);
		return null;
	}

	const handleButtonVoltar = () => {
		dispatch(clearNotifications());
		dispatch(consultaPesquisaObservacaoClear());
		dispatch(cadastroRgConfigRedicao());

		if (cadastroRg.config.novo) {
			history.push(ROUTE_IIRGD_CADASTRO);
			return;
		}

		history.push(ROUTE_IIRGD_EDICAO);
	};

	return (
		<>
			{showDivergence && (
				<DivergenceForm
					initialData={formData}
					consultarCinData={consultarCinData}
					onUploadComplete={setDivergenceComplete}
				/>
			)}
			{showCiptea && (
				<CipteaForm
					initialData={formData}
					onCipteaSubmit={setCipteaComplete}
					uploadDivergenceComplete={divergenceComplete}
					divergenceScreenEnabled={showDivergence}
				/>
			)}

			{/* <Row gutter={[0, 20]} justify="center" style={{ marginTop: '20px' }}>
				<Col>
					<ButtonImage
						src="avancar"
						onClick={handleAdvance}
						disabled={isAdvanceDisabled()}
					/>
				</Col>
			</Row> */}
			<ButtonVoltar navigate={false} onClick={handleButtonVoltar} />
		</>
	);
};

export default DivergenciasScreen;
